import React from "react";
import NavBar from "../components/NavBar";

const FoodyTermsPage = ({ language, onLanguageChange, t }) => {
  const thirdPartyProviders = t("foodyTerms.thirdParty.providers") || [];

  return (
    <div className="page foody-page support-page" id="foody-terms-top">
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/apps/foody", label: t("foodySupport.back") },
          {
            href: "/apps/foody/static/support",
            label: t("foodySupport.badge"),
          },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("foodyTerms.badge")}</span>
            <h1>{t("foodyTerms.hero.title")}</h1>
            <p>{t("foodyTerms.hero.desc")}</p>
            <p className="support-muted">
              {t("foodyTerms.hero.effectiveDate")}
            </p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("foodyTerms.acceptance.title")}</h3>
              <p>{t("foodyTerms.acceptance.p1")}</p>
              <p>{t("foodyTerms.acceptance.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyTerms.intellectualProperty.title")}</h3>
              <p>{t("foodyTerms.intellectualProperty.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyTerms.serviceChanges.title")}</h3>
              <p>{t("foodyTerms.serviceChanges.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyTerms.deviceSecurity.title")}</h3>
              <p>{t("foodyTerms.deviceSecurity.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyTerms.thirdParty.title")}</h3>
              <p>{t("foodyTerms.thirdParty.desc")}</p>
              <ul className="support-list">
                {thirdPartyProviders.map((provider) => (
                  <li key={provider.name}>
                    <a
                      href={provider.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {provider.name}
                    </a>
                  </li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("foodyTerms.connectivity.title")}</h3>
              <p>{t("foodyTerms.connectivity.p1")}</p>
              <p>{t("foodyTerms.connectivity.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyTerms.liability.title")}</h3>
              <p>{t("foodyTerms.liability.p1")}</p>
              <p>{t("foodyTerms.liability.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyTerms.ai.title")}</h3>
              <p>{t("foodyTerms.ai.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyTerms.updates.title")}</h3>
              <p>{t("foodyTerms.updates.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyTerms.changes.title")}</h3>
              <p>{t("foodyTerms.changes.desc")}</p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("foodyTerms.contact.title")}</h2>
            <p>
              {t("foodyTerms.contact.desc")}
              <br />
              <a href="mailto:support-foody@wodaslabs.com">
                support-foody@wodaslabs.com
              </a>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default FoodyTermsPage;
